<template>
  <span class="spinner" aria-hidden="true" />
</template>

<style scoped>
.spinner {
  display: inline-block;
  width: 1.25em;
  height: 1.25em;
  border: 2px solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* base.css disables animations under prefers-reduced-motion; give those
   users a static but still visible indicator */
@media (prefers-reduced-motion: reduce) {
  .spinner {
    border-right-color: currentcolor;
    opacity: 0.5;
  }
}
</style>
